<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter"><div epub:type="pagebreak" id="page5" title="5">
<h2 class="pt" id="part01"><em>BATTLE TALES</em></h2>
</div></section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?2605d948